<template>
  <div class="right-home product-list">
    <div class="breadcrumb">售后查询</div>
    <div class="right-main">
      <!--      查询订单-->
      <el-form :inline="true" :model="formInline" label-width="80px">
        <el-row>
          <el-col :span="5.5">
            <el-form-item label="售后单号:">
              <el-input v-model="formInline.postsaleNo" placeholder="请输入售后单号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5.5">
            <el-form-item label="订单号:">
              <el-input v-model="formInline.orderNo" placeholder="请输入售后单号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5.5">
            <el-form-item label="联系方式:">
              <el-input v-model="formInline.phone" placeholder="请输入联系方式" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7.5">
            <el-form-item label="申请日期:">
              <el-date-picker v-model="date" type="daterange" clearable format="yyyy-MM-dd" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="5.5">
            <el-form-item label="业务:">
              <el-select clearable v-model="formInline.salesmanId" :filter-method="selectSalemanList" filterable placeholder="请输入业务名称">
                <el-option v-for="item in salemanList" :key="item.id" :label="item.fullName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5.5">
            <el-form-item label="平台号:">
              <el-select clearable v-model="formInline.storeId" :filter-method="filterMethod" filterable placeholder="请输入平台号">
                <el-option v-for="item in storeListByCode" :key="item.id" :label="item.code" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5.5">
            <el-form-item label="审核状态:">
              <!-- <el-input v-model="formInline.auditStatus" placeholder="请输入审核状态" clearable></el-input> -->
              <el-select v-model="formInline.auditStatus" placeholder="请选择" clearable>
                <el-option v-for="(k, v) in $config['auditStatus']" :key="k" :label="k" :value="v"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="fn-right form-btn" style="margin-top:0;">
            <el-button class="search-ok" round>导出excel</el-button>
            <el-button class="search-ok" @click="queryInfo.pageNum = 1, onSubmit()" round>查询</el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="data-list">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column label="产品ID" prop="id" min-width="10px"></el-table-column>
        </el-table>
      </div>
      <!--    分页-->
      <v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="changePage"></v-pagination>
    </div>
    <!-- 确认删除 -->
    <el-dialog :close-on-click-modal="false" title="确认提示" :visible.sync="deleteDialog" width="30%">
      <span>是否确认删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false">取 消</el-button>
        <el-button type="primary">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
 <script>
import VPagination from '@/components/Pagination/index.vue'
import { postsalePage } from '@/api/oms.js'
import { storeTypeGetStoreTypeList, storeQueryListByCode, getSalesmanByFullName, storeQueryListByName, getAllUsersByUserName } from '@/api/crm'

export default {
  components: {
    VPagination
  },
  data () {
    return {
      date: '',
      salemanList: [],
      storeListByCode: [],
      deleteDialog: false,
      formInline: {
        auditStatus: '',
        dateEnd: '',
        dateStart: '',
        orderNo: '',
        phone: '',
        postsaleNo: '',
        salesmanId: '',
        storeId: ''
      },
      tableData: [],
      queryInfo: {
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      }
    }
  },
  created () {
    this.onSubmit()
  },
  watch: {
    date (val) {
      console.log(val)
      if (val) {
        this.formInline.dateStart = val[0] + ' 00:00:00'
        this.formInline.dateEnd = val[1] + ' 23:59:59'
      } else {
        this.formInline.dateStart = ''
        this.formInline.dateEnd = ''
      }
    }
  },
  methods: {
    selectSalemanList (val) {
      if (val.trim()) {
        getSalesmanByFullName(val).then(res => {
          if (res.data.success) {
            this.salemanList = res.data.data
          }
        })
      }
    },
    filterMethod (val) {
      if (val.trim()) {
        storeQueryListByCode(val).then(res => {
          if (res.data.success) {
            this.storeListByCode = res.data.data
          }
        })
      }
    },
    onSubmit () {
      postsalePage({
        vo: Object.fromEntries(Object.entries(this.formInline).map(([key, value]) => [key, value === '' ? null : value])),
        params: { page: this.queryInfo.pageNum, size: this.queryInfo.pageSize }
      })
        .then(res => {
          if (res.data.success) {
            this.queryInfo.total = res.data.data.total
            this.tableData = res.data.data.content
          }
        })
    },
    changePage (val) {
      this.queryInfo = val
      this.getProList(this.queryInfo)
    }
  }
}
</script>
 <style scoped lang="less">
 @deep: ~">>>";
 </style>
